import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useValidation } from 'gw-portals-validation-react';
import { LocalDateUtil } from 'gw-portals-util-js';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { useAuthentication } from 'gw-digital-auth-react';
import { ModalNextProvider } from '@jutro/components';
import { ViewModelForm,ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import metadata from './PolicyDetailsPage.metadata.json5';
import {CanceledPolicyComponent,AccountContactSearchComponent} from 'gw-capability-gateway-react';
import {AdditionalInsuredInterestComponent} from 'gw-capability-policychange-ho-react';
import PortalUtil from '../../../../utils/PortalUtil';
import { messages as commonMessages } from 'gw-platform-translations';
import messages from './PolicyDetailsPage.messages';
import { UserService, OrganizationService } from 'gw-capability-gateway';

function PolicyDetailsPage(props) {

    const { initialValidation, isComponentValid, onValidate, registerComponentValidation } = useValidation('PolicyDetailsPage');
    const { wizardData: submissionVM, updateWizardData, isNewSubmission, additionalWizardData, changeNextSteps, updateAdditionalWizardData } = props;
    const [isPageInitialized, setPageInitialized] = useState(false);
    const [offerings , setOfferings] = useState([]);
    const { authHeader } = useAuthentication();
    const [accountContacts, setAccountContacts] = useState([{}]);
    const viewModelService = useContext(ViewModelServiceContext);
    const {dateUtil} = PortalUtil;
    const isPackageDetailsValid = useCallback(() => {
        return !_.isEmpty(submissionVM.baseData.offering.value)

    },[submissionVM] )
    const [isProducerCodesforFlexFund, setProducerCodesforFlexFund] = useState(false);

    const shouldShowPriorCarrierElements = (path, valueToMatch = true) => {
        const value = _.get(submissionVM, path);
        return value.code !== valueToMatch;
    };
    const [producerCodeOrgValue, updateProducerCodeValue] = useState([]);

    useEffect(() => {        
        setPageInitialized(true);
        registerComponentValidation(isPackageDetailsValid);
        // The above action only need to run once when the page is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
     
        const _contacts = submissionVM.baseData.account.accountContacts.value.map((c) => {
                c['id'] = c.publicID;
                return c;
          });
        _contacts.push({ id: "placeholder", displayName: "Search Existing Contacts" });
        setAccountContacts(_contacts);
        const accProducerCodes = [] ;
        const producerCodesPromise = OrganizationService.getProducerCodeForOrganization(submissionVM.baseData.value.account.producerCodes[0].organizationDTO, authHeader);
        producerCodesPromise.then((producerCodesResponse) => {
            _.each(producerCodesResponse, (producerCodeValue) => {
                accProducerCodes.push({code : producerCodeValue.code,name :  producerCodeValue.displayValue});
            });
            updateProducerCodeValue(accProducerCodes);
        }, () => {
        });

        LoadSaveService.getOfferings(
            submissionVM.quoteID.value,
            authHeader
        ).then((response) => {
            if(response != undefined) {
              const offerings =  response.map(offering => {
                    return { code : offering.codeIdentifier,
                            name : offering.name}

                });
                setOfferings([...offerings]);
            }

        });

        LoadSaveService.isProducerCodesforFlexFund(
            submissionVM.baseData.producerCode.value,
            authHeader
        ).then((response) => {
            if(response === true){
                setProducerCodesforFlexFund(true);
            }
        });
        if(submissionVM.baseData.periodStatus.value.code === 'Quoted') {
            const _additionalWizardData = additionalWizardData
            _additionalWizardData['isFarmLineQuoted'] =  true
            updateAdditionalWizardData(_additionalWizardData);
        }

        if(!submissionVM.baseData.isCommercialLineExist.value){
            changeNextSteps(additionalWizardData.steps.filter((step) => {
                return step.id != 'FARMCommercialDetailsPage' && step.id != 'FARMPolicyDetailsPage';
            }))
        } else{
            changeNextSteps(additionalWizardData.steps.filter((step) => {
                return step.id != 'FARMPolicyDetailsPage';
            }))
        }
        

    }, [registerComponentValidation, isPackageDetailsValid]);


    const handleOfferingSelectionChange = useCallback(
        (value) => {
            _.set(submissionVM, 'baseData.offering', value);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const handlePriorCancelHistoryChange = (value) => {
        _.set(submissionVM, 'baseData.hasAnyCancel', value);
        submissionVM.baseData.priorCancelledRecords.value = []
        updateWizardData(submissionVM);
    }

    const handleCommercialValueChange = (value) => {
        _.set(submissionVM, 'baseData.isCommercialLineExist', value);        
        if(!submissionVM.baseData.isCommercialLineExist.value){
            changeNextSteps(additionalWizardData.steps.filter((step) => {
                return step.id != 'FARMCommercialDetailsPage' && step.id != 'FARMPolicyDetailsPage';
            }))
        } else{
            changeNextSteps(additionalWizardData.steps.filter((step) => {
                return step.id != 'FARMPolicyDetailsPage';
            }))
        }
        updateWizardData(submissionVM);
    }

    const onNext = useCallback(async () => {
        if(submissionVM.baseData.hasAnyCancel.value && submissionVM.baseData.priorCancelledRecords.children.length < 1) {
            ModalNextProvider.showAlert({
                title: messages.errorsOnCurrentPage,
                message: messages.errorOnNotFilledCanceledPolicyData,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;

        }
        _.unset(submissionVM.value, 'bindData');
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );

        return submissionVM;
    }, [submissionVM, authHeader]);

    const updatePackage = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        // _.set(newSubmissionVM, `lobData.homeowners.allCoverables.children.${index}.value`, value);
        //_.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(newSubmissionVM);
    }

    const updateAdditionalInsured = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, `baseData.additionalNamedInsureds.children.${index}.value`, value);
       // _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(newSubmissionVM);
    }

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            if(path == 'baseData.termType' || path == 'baseData.periodStartDate'){
                const term = _.get(submissionVM, 'baseData.termType.value');
                const startDate = _.get(submissionVM, 'baseData.periodStartDate.value');
                let endDate = null
                if(term.code == "HalfYear"){
                    endDate = new Date(new Date(startDate.year, startDate.month, startDate.day).setMonth(new Date(startDate.year, startDate.month, startDate.day).getMonth() + 6))
                }
                else {
                    endDate = new Date(new Date(startDate.year, startDate.month, startDate.day).setMonth(new Date(startDate.year, startDate.month, startDate.day).getMonth() + 12))
                }
                endDate = {year: endDate.getFullYear(), month: endDate.getMonth(), day: endDate.getDate()}
                _.set(submissionVM, 'baseData.periodEndDate', endDate)

            }
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );
    const writeAdditionalInsuredValue = useCallback(
        (value, path) => {
            _.set(submissionVM, `baseData.${path}`, value);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const handleTermTypeChange = useCallback( async (value) => {
        _.set(submissionVM, 'baseData.termType', value);
        _.unset(submissionVM.value, 'bindData');
       const response = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        
        _.set(submissionVM, 'baseData.periodEndDate', response.baseData.periodEndDate);
        updateWizardData(submissionVM);

    }, [submissionVM, updateWizardData])

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showRequired: true
        },
        coverageStartDate: {
            minDate: dateUtil.addDaysToLocalDate(LocalDateUtil.today(), -15),
            onValueChange: writeValue
        },
        termType:{
            onValueChange: writeValue
        },
        offeringSelection: {
            availableValues : offerings,
            onValueChange: handleOfferingSelectionChange
        },
        cancelledByInsuranceCompany:{
            onValueChange: handlePriorCancelHistoryChange
        },
        canceledPolicycomponentID: {
            submissionVM : submissionVM,
            updateWizardData: updateWizardData,
            visible : submissionVM.baseData.hasAnyCancel.value == true
        },

        accountContactSearchId: {
            submissionVM: submissionVM,
            accountContacts: submissionVM.baseData.account.accountContacts,
            accountNumber: submissionVM.baseData.accountNumber,
            updatePackage: updatePackage,
            authHeader: authHeader,
            onValueChange: writeValue,
            updateWizardData:updateWizardData
        },
        additionalInsured: {
            coverableVM: submissionVM.baseData,
            accountContacts: accountContacts,
            accountNumber: submissionVM.baseData.accountNumber.value,
            type: 'additionalInsured',
            updatePackage: updateAdditionalInsured,
            authHeader: authHeader,
            onValueChange: writeAdditionalInsuredValue,
            isSubmission: true,
            jobID: submissionVM.quoteID.value,
            updateAccountContacts: setAccountContacts,
        },
        termType: {
            onValueChange : handleTermTypeChange
        },
        submissionProducerCode: {
            availableValues: producerCodeOrgValue
        },
        overrideAmount: {
            visible : isProducerCodesforFlexFund === true
        },
        // commercialLineExist:{
        //     onValueChange: handleCommercialValueChange
        // },
        multilineDiscountSelect:{
            availableValues: submissionVM.baseData.multiLineApplicableDiscounts.value.map((item)=>{
                return {code:item, name:item}
            })
        }
    };

    if (!isPageInitialized) {
        return null;
    }

    const skipIntialValidation = async () => {
        const isValid = await initialValidation();
        return isValid && !isNewSubmission;
    }

    const resolvers = {
        resolveComponentMap: {
            canceledpolicycomponent: CanceledPolicyComponent,
            accountContactSearch: AccountContactSearchComponent,
            additionalInsuredInterestComponent: AdditionalInsuredInterestComponent
            
        },
    };


    return (
        <WizardPage
            showPrevious={false}
            onNext={onNext}
            skipWhen={skipIntialValidation}
            disableNext={!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

PolicyDetailsPage.propTypes = wizardProps;
export default PolicyDetailsPage;
